import { ReactNode } from 'react';

// The small tinted notice under the plan card / inside the settings modals.
// Shared by both surfaces so the tone→palette mapping lives in exactly one place.
export function PlanNotice({ tone, children }: { tone: 'success' | 'error' | 'muted'; children: ReactNode }) {
  const palette = {
    success: { bg: 'rgba(var(--ds-green-success-500-rgb), 0.1)', border: 'rgba(var(--ds-green-success-500-rgb), 0.32)', dot: 'rgba(var(--ds-green-success-500-rgb), 0.95)', ink: 0.85 },
    error: { bg: 'rgba(var(--ds-red-400-rgb), 0.1)', border: 'rgba(var(--ds-red-400-rgb), 0.32)', dot: 'rgba(var(--ds-red-400-rgb), 0.95)', ink: 0.85 },
    muted: { bg: 'rgba(var(--hairline-rgb),0.05)', border: 'rgba(var(--hairline-rgb),0.14)', dot: null, ink: 0.7 },
  }[tone];
  return (
    <div
      style={{
        ...styles.container,
        background: palette.bg,
        border: `1px solid ${palette.border}`,
        color: `rgba(var(--ink-rgb),${palette.ink})`,
      }}
    >
      {palette.dot && <span aria-hidden style={{ ...styles.dot, background: palette.dot }} />}
      <span style={styles.content}>{children}</span>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '10px 13px',
    borderRadius: 10,
    fontSize: 12.5,
    lineHeight: 1.45,
  },
  dot: { width: 7, height: 7, flexShrink: 0, borderRadius: '50%' },
  content: { minWidth: 0 },
} satisfies Record<string, React.CSSProperties>;
